import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AppErrorPageRobotComponentComponent } from '../app-error-page-robot/app-error-page-robot.component.component';
import { RouterLink } from '@angular/router';

@Component({
  imports: [
    TranslateModule,
    AppErrorPageRobotComponentComponent,
    RouterLink,
  ],
  selector: 'sma-web-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['page-not-found.component.scss'],
})
export class PageNotFoundComponent { }
